import { useGetQuery } from '../../../__generated__/chirp/com/hubspot/learning/center/assignments/rpc/PortalChirpService.hooks';
export const usePortal = ({
  portalId,
  skip
}) => {
  const {
    data,
    loading,
    error
  } = useGetQuery({
    skip,
    variables: {
      targetPortalId: portalId
    }
  });
  return {
    portal: data === null || data === void 0 ? void 0 : data.portalResponse,
    portalLoading: loading,
    portalError: error
  };
};